import React from 'react';
import { Grid } from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { SecondaryButton } from '@/styles/blocks';
import { MultiCombobox } from '@onward-delivery/design/multi-combobox';
import { Body1, SectionLabel } from '../blocks';
import { useApplyToShipper } from './hooks';

const ApplyToShipperBar = (props) => {
    const { disabled } = props;
    const { selectedShipperIds, setSelectedShipperIds, shipperOptions, selectedShipperApplied, canApply, apply } =
        useApplyToShipper(props);

    return (
        <Grid
            container
            direction="column"
            css={css`
                padding: 0 20px 16px;
                gap: 8px;
                flex-wrap: nowrap;
                background: ${colors.white.primary};
            `}
        >
            <SectionLabel>Shipper</SectionLabel>
            <Grid
                container
                css={css`
                    flex-wrap: nowrap;
                    gap: 10px;
                    align-items: center;
                `}
            >
                <Grid
                    item
                    css={css`
                        flex: 1 1 0;
                        min-width: 0;
                    `}
                >
                    {/* Wrapper must stay bare: `.onward-design .flex` matches descendants only. */}
                    <div className="onward-design">
                        <MultiCombobox
                            options={shipperOptions}
                            value={selectedShipperIds}
                            onValueChange={setSelectedShipperIds}
                            disabled={disabled}
                            placeholder="Select Shipper"
                            searchPlaceholder="Search..."
                            emptyText="No shippers found."
                            // Shares its row with Attach.
                            maxDisplay={1}
                        />
                    </div>
                </Grid>
                <Grid
                    item
                    css={css`
                        flex-shrink: 0;
                    `}
                >
                    <SecondaryButton
                        onClick={apply}
                        disabled={!canApply}
                        css={css`
                            height: 40px;
                            min-width: 0;
                            padding: 6px 16px;
                        `}
                    >
                        Attach
                    </SecondaryButton>
                </Grid>
            </Grid>
            {selectedShipperApplied ? (
                <Body1
                    css={css`
                        display: inline-flex;
                        align-items: center;
                        gap: 4px;
                        font-size: 12px;
                        color: ${colors.greens.primary};
                    `}
                >
                    <CheckCircle
                        css={css`
                            font-size: 14px;
                        `}
                    />
                    {selectedShipperIds.length === 1
                        ? 'Already applied to this shipper'
                        : 'Already applied to these shippers'}
                </Body1>
            ) : null}
        </Grid>
    );
};

export default ApplyToShipperBar;
